// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"438":"Login","726":"Index"}[chunkId] + "." + {"438":"b4a41a91","726":"f8090b8c"}[chunkId] + ".js";
};